import * as React from "react";
import { forwardRef } from "react";
const SvgCross = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21.5999 10.4004L10.3999 21.6004M21.5999 21.6004L10.3999 10.4004L21.5999 21.6004Z", stroke: "#BDBDBD", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCross);
export { ForwardRef as ReactComponent };
